import styled, { css } from 'styled-components'

export const IconWrapper = styled.span`
  display: inline-block;
  position: relative;
  // padding-left: 15em;
  line-height: 0;
`

export const buttonStyle = () => css`
  ${() =>
    css`
      background-color: #8bc34a;
      border-radius: 4px;
      color: black;
      cursor: 'pointer';
      font-size: 16px;
      font-weight: 600;
      line-height: 1.4;
      min-width: 118px;
      padding: 10px;
      position: relative;
      text-decoration: none;
      width: auto;
      text-align: center;
    `}
`

export const ButtonStyled = styled.button`
  ${buttonStyle}
  position: relative;
`

export const Inner = styled.span`
  align-items: center;
  display: inline-block;
  text-align: center;
`
